import SEOHead from "@/components/base/SEOHead";
import ScrollToTop from "@/components/base/ScrollToTop";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import HotArticles from "./components/HotArticles";
import LatestArticles from "./components/LatestArticles";
import CategoryGrid from "./components/CategoryGrid";

export default function Home() {
  const baseUrl = "https://heiliao.wan.com";
  const pageTitle = "黑料wan网 – 最新黑料爆料汇总平台";
  const pageDesc = "黑料wan网是您获取最新黑料爆料、网红明星内幕的首选平台。汇聚全网热门黑料资讯，第一时间掌握娱乐圈、网红界最劲爆内幕信息，每日更新不间断。";

  const schemaJson = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": `${baseUrl}/#organization`,
        name: "黑料wan网",
        url: baseUrl,
        description: "最新黑料爆料汇总平台，汇聚全网热门黑料资讯",
        sameAs: ["https://weibo.com/heiliao", "https://weixin.qq.com/heiliao"],
      },
      {
        "@type": "WebSite",
        "@id": `${baseUrl}/#website`,
        url: baseUrl,
        name: "黑料wan网",
        description: pageDesc,
        publisher: { "@id": `${baseUrl}/#organization` },
      },
      {
        "@type": "WebPage",
        "@id": `${baseUrl}/#webpage`,
        url: baseUrl,
        name: pageTitle,
        description: pageDesc,
        isPartOf: { "@id": `${baseUrl}/#website` },
        about: { "@id": `${baseUrl}/#organization` },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title={pageTitle}
        description={pageDesc}
        keywords="黑料wan网,黑料爆料最新,网红黑料内幕,明星黑料汇总,娱乐圈黑料,黑料吃瓜平台,最新黑料资讯"
        canonicalUrl={baseUrl}
        schemaJson={schemaJson}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <HotArticles />
        <LatestArticles />
        <CategoryGrid />
      </main>
      <Footer />
    </>
  );
}